import { useMutation } from '@tanstack/react-query';

import { AxiosError } from 'axios';

import {
  PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody,
  TPrototypePartialDto,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useCreateScenarioPartialMutation = (
  workspaceId?: string,
  signal?: AbortSignal
) => {
  const { partials } = useAvApi();

  return useMutation<
    TPrototypePartialDto | undefined,
    AxiosError,
    {
      partial: PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody;
      prototypeId: string;
    }
  >({
    mutationKey: ['create-scenario-partial-mutation'],
    mutationFn: async ({
      partial,
      prototypeId,
    }: {
      partial: PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody;
      prototypeId: string;
    }) => {
      if (!workspaceId) return;

      const pageData = new FormData();
      pageData.append('index', partial.index);
      pageData.append('image', partial.image);
      pageData.append('name', partial.name);
      pageData.append('type', partial.type);
      pageData.append('data', partial.data);
      pageData.append('fileName', partial.fileName);

      // TODO fix any
      /* eslint-disable */
      const res =
        await partials.postProjectsPrototypesPartialsByProjectIdAndPrototypeId(
          pageData as any,
          {
            projectId: workspaceId,
            prototypeId,
          },
          {
            headers: {
              'Content-Type': 'multipart/form',
            },
            signal,
          }
        );
      /* eslint-disable */
      return res.data;
    },
  });
};
